import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from '../../i18n/TranslationProvider'

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import Sallie from '../Sallie'
import SubmitButton from '../StyledComponents/SubmitButton'

import futureView from '../../images/FutureView.jpg'

const Register = () => {
  const history = useHistory()
  const { t } = useTranslation()

  const handleClick = () => {
    history.push('/BasicInfo')
  }

  return (
    <Row>
      <Col md={6} className="order-last order-md-first">
        <Sallie text={t('register.sallieGreeting')} />
        <p>{t('register.intro.partOne')}</p>
        <p>{t('register.intro.partTwo')}</p>

        <h6>{t('register.steps.header')}</h6>
        <p>{t('register.steps.threeSteps')}</p>

        <ol style={{ listStylePosition: 'inside', paddingLeft: 0 }}>
          <li>{t('register.steps.stepOne')}</li>
          <li>{t('register.steps.stepTwo')}</li>
          <li>{t('register.steps.stepThree')}</li>
        </ol>
        <Row>
          <Col className="justify-content-center d-flex justify-content-md-start">
            <SubmitButton type="button" onClick={handleClick}>
              {t('register.startButton')} &gt;
            </SubmitButton>
          </Col>
        </Row>
      </Col>
      <Col md={6} className="order-first order-md-last">
        <div>
          <h6 className="text-center">{t('register.futureDashboard')}</h6>
          <img className="w-100" src={futureView} alt="future view" />
        </div>
      </Col>
    </Row>
  )
}

export default Register